"use client";

import Link from "next/link";
import { useState } from "react";
import styles from "./actionButton.module.css";

interface ActionButtonProps {
  label: string;
  link?: string;
  color?: string;
  hoverColor?: string;
  onClick?: (e: React.MouseEvent) => void;
  style?: React.CSSProperties;
  showIcon?: boolean;
}

export default function ActionButton({
  label,
  link = "#",
  color = "#008748",
  hoverColor = "#00b85c",
  onClick,
  style = {},
  showIcon = true,
}: ActionButtonProps) {
  const [hovered, setHovered] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      e.preventDefault();
      onClick(e);
    }
  };

  const buttonContent = (
    <div
      className={styles.button}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={handleClick}
      style={{
        backgroundColor: hovered ? hoverColor : color,
        boxShadow: hovered
          ? `0 12px 28px ${hoverColor}50, 0 2px 6px ${hoverColor}30`
          : `0 8px 22px ${color}35, 0 2px 4px ${color}20`,
        transform: hovered ? "translateY(-2px)" : "translateY(0)",
        ...style,
      }}
    >
      {/* Label */}
      <span className={styles.label}>{label}</span>

      {/* Icon */}
      {showIcon && (
        <span
          className={styles.icon}
          style={{
            transform: hovered ? "translateX(4px)" : "translateX(0)",
          }}
        />
      )}

      {/* Shine effect overlay */}
      <span
        className={styles.shine}
        style={{
          transform: hovered ? "translateX(100%)" : "translateX(-100%)",
        }}
      />
    </div>
  );

  return (
    <Link href={link} style={{ textDecoration: "none" }}>
      {buttonContent}
    </Link>
  );
}
